import Avatar from "antd/es/avatar/avatar";
import Loader from "Components/Loader";
import { useGetMeQuery } from "hooks/Auth/useGetMeQuery";
import { useGetMyOrdersQuery } from "hooks/Driver/useGetMyOrdersQuery";
import { useGetMyOrderStats } from "hooks/Driver/useGetMyOrderStats";
import DriverDashboard from "Layout/DriverDashboard";
import { Status } from "Pages/User/OrderManagement/Components/Status";
import { useState } from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import { Boxes } from "../DriverOrder";

const DriverHome = () => {
  const [payload, setPayload] = useState({
    startDate: "",
    endDate: "",
    status: "shipped",
    deliveryMethod: "deliveryMethod",
  });

  const { data: orders, isLoading: isLoadingOrders } =
    useGetMyOrdersQuery(payload);
  const { data: orderStats, isLoading } = useGetMyOrderStats(payload);

  const { data } = useGetMeQuery();
  const driver = data?.data;

  return (
    <DriverDashboard back={false}>
      <div className="flex items-center bg-[#f3f3f3] rounded-md justify-between p-[10px] mb-[10px]">
        <span className="font-medium">
          <span className="text-primary-foreground">Status:</span>
          <span className="text-black">Available</span>
        </span>
        <button className="text-white bg-orange rounded-md px-[7px] py-[12px] text-[13px] font-medium">
          Set As Available
        </button>
      </div>
      <div className="flex bg-[#f3f3f3] rounded-md justify-between  mb-[10px]">
        <span className="w-6/12 p-[10px]">
          <h3 className="text-[12px] text-primary-foreground">
            Total Number of Delivery
          </h3>
          <p className="text-black font-medium">
            {orderStats && orderStats?.data?.totalOrders}
          </p>
        </span>
        <span className="w-6/12 border-l-[1px] border-[#e6e6e6] pl-[15px] p-[10px]">
          <h3 className="text-[12px] text-primary-foreground">
            This Week Delivery
          </h3>
          <p className="text-black font-medium">
            {orderStats && orderStats?.data?.thisWeekOrders}
          </p>
        </span>
      </div>

      <h3 className="mt-[30px] mb-[25px] text-black font-bold">
        Recent Activity
      </h3>
      {isLoadingOrders && <Loader />}
      {orders?.data?.docs &&
        orders?.data?.docs
          .slice(0, 5)
          .map(
            ({
              id,
              orderStatus,
              orderNo,
              createdAt,
              customerAddress,
              statusLogs,
            }: {
              id: string;
              orderStatus: string;
              orderNo: string;
              createdAt: string;
              customerAddress: string;
              statusLogs: any;
            }) => (
              <Link
                to={`/driver/orders/${id}`}
                key={id}
                className="flex flex-row gap-3 py-3 border-b-[1px] border-b-[#e4e4e4]"
              >
                <Boxes />
                <div className="flex-1">
                  <div>
                    <h3>{orderNo}</h3>
                    <p className="text-[13px]">{customerAddress}</p>
                    <Moment
                      interval={0}
                      format="DD-MM-YYYY hh:mm a"
                      className="text-[#939393] text-[13px]"
                    >
                      {createdAt}
                    </Moment>
                  </div>
                </div>
                <span className="w-[80px] flex justify-end text-[13px]">
                  <Status value={statusLogs.at(-1)?.status} />
                </span>
              </Link>
            )
          )}
    </DriverDashboard>
  );
};

export default DriverHome;
